import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { SetupState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: SetupState = getDefaultState();

const namespaced: boolean = true;

export const setup: Module<SetupState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
